import React from 'react';

const Home = () => (
  <main>
    <div className="title">
      <h2>Welcome to our pages!</h2>
    </div>
    <div className="description">
      <div className="text">
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
        </p>
        <p>
          amet consectetur adipisicing elit. Maxime mollitia,molestiae quas vel sint commodi
        </p>
        <p>
          molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! Impedit
        </p>
      </div>
      <div className="text">
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
        </p>
        <p>
          amet consectetur adipisicing elit. Maxime mollitia,molestiae quas vel sint commodi
        </p>
        <p>
          molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! Impedit
        </p>
      </div>
    </div>
  </main>
);

export default Home;
